import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AdminPageHeader } from '@/components/admin/AdminPageHeader';

export const Route = createFileRoute('/admin/reference')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/admin/reference' || location.pathname === '/admin/reference/') {
      throw redirect({ to: '/admin/reference/occupations' });
    }
  },
  component: ReferenceLayout,
});

function ReferenceLayout() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        eyebrow="Reference data"
        title="Reference data"
        description="The ATO catalogues offered in the Personal section. Pick a catalogue from the sidebar to add, rename, or remove entries — an entry in use by a return can't be deleted."
      />
      <Outlet />
    </div>
  );
}
